<div class="aeg-invoices">
    <vl-info-tile tag-name="div" title="Facturen en betalingsbewijzen">
        <template v-if="!isMobile">
            <div class="aeg-invoices-search aeg-u-bg-alt">
                <aeg-search-invoice @search="onSearch" :default-query="defaultSearchQuery" />
            </div>
        </template>
        <template v-if="error">
            <div class="aeg-invoices__error">
                <div class="aeg-invoices__error-text">
                    <vl-icon icon="warning" mod-error/>
                    Er ging iets mis bij het ophalen van uw facturen en betalingsbewijzen.
                </div>
                <div>
                    <vl-link @click.prevent="loadInvoices" mod-icon-before icon="text-redo" mod-block>
                        Opnieuw proberen
                    </vl-link>
                </div>
            </div>
        </template>
        <template v-else-if="isMobile">
            <template v-if="emptyState">
                <div class="aeg-invoices__empty">
                    U heeft nog geen facturen of betalingsbewijzen.
                </div>
            </template>
            <template v-else>
                <div v-if="isLoading" class="aeg-invoices__loading">
                    <vl-loader />
                </div>
                <div v-else class="aeg-invoices-card" v-for="invoice in invoices.items" :key="invoice.invoiceNumber">
                    <vl-title tag-style="h6">
                        {{ formatDate(invoice.documentDate) }} - {{ invoice.invoiceNumber }} <span v-if="invoice.customerReference">{{ invoice.customerReference }}</span>
                    </vl-title>
                    <div>
                        {{ getDocumentTypeLabel(invoice.documentType) }}
                    </div>
                    <div class="aeg-invoices-card__footer">
                        <div style="margin-right: auto">
                            <vl-title tag-name="span" tag-style="h6" :class="{'aeg-invoices-details__topup': isTopUpType(invoice.documentType) }">
                                <vl-icon
                                        mod-icon-only
                                        :icon="getInvoiceTypeIcon(invoice.documentType, invoice.paymentMethod)"
                                        :class="{'aeg-details-table-details__topup': isTopUpType(invoice.documentType)}"
                                />
                                &nbsp;
                                {{
                                    isTopUpType(invoice.documentType) ? `+ ${formatCurrency(invoice.totalPrice)}` : formatCurrency(invoice.totalPrice)
                                }}
                            </vl-title>
                        </div>
                        <vl-link v-if="invoice.directPdfUrl" :href="invoice.directPdfUrl" mod-button class="vl-button vl-button--tertiary" icon="file-office-pdf" mod-icon-after>
                            PDF
                        </vl-link>
                        <vl-link v-if="invoice.directCsvUrl" :href="invoice.directCsvUrl" mod-button class="vl-button vl-button--tertiary" icon="file-office-xls" mod-icon-after>
                            CSV
                        </vl-link>
                    </div>
                </div>
                <div class="aeg-invoices-pager">
                    <aeg-pagination :page-size="invoices.pagingInfo.pageSize" :current-page="invoices.pagingInfo.page"
                                    :results="invoices.pagingInfo.totalPages"
                                    :total="invoices.pagingInfo.totalItems"
                                    @page-change="changePage" />
                </div>
            </template>
        </template>
        <template v-else>
            <vl-data-table class="aeg-datatable" :mod-zebra="!emptyState || isLoading" :mod-hover="!emptyState || isLoading">
                <thead class="aeg-invoices-header">
                <tr>
                    <th>Datum<vl-icon icon="arrow-down" /></th>
                    <th>Doc nummer</th>
                    <th>Document</th>
                    <th>Eigen referentie</th>
                    <th class="aeg-invoices-header__amount">Bedrag</th>
                    <th class="aeg-invoices-header__payment vl-u-align-center">Betaald</th>
                    <th class="aeg-invoices-header__download vl-u-align-center">PDF</th>
                    <th class="aeg-invoices-header__download vl-u-align-center">CSV</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="isLoading">
                    <td colspan="9">
                        <div class="aeg-datatable__loading">
                            <vl-loader message="De gegevens worden geladen. Even geduld, a.u.b."/>
                        </div>
                    </td>
                </tr>
                <tr v-else-if="emptyState">
                    <td colspan="9">
                        <div class="aeg-datatable__empty">
                            U heeft nog geen facturen of betalingsbewijzen.
                        </div>
                    </td>
                </tr>
                <tr v-else v-for="invoice in invoices.items" :key="invoice.invoiceNumber">
                    <td>{{ formatDate(invoice.documentDate) }}</td>
                    <td>{{ invoice.invoiceNumber }}</td>
                    <td>{{ getDocumentTypeLabel(invoice.documentType) }}</td>
                    <td>{{ invoice.customerReference }}</td>
                    <td>
                        <div class="aeg-invoices-details">
                            <span class="aeg-invoices-details-type">
                                <vl-icon mod-icon-only :icon="getInvoiceTypeIcon(invoice.documentType, invoice.paymentMethod)" :class="{'aeg-details-table-details__topup': isTopUpType(invoice.documentType)}" />
                            </span>
                            <vl-icon icon="euro" :class="{'aeg-invoices__payment-icon': isTopUpType(invoice.documentType)}"/>
                            <span :class="{'aeg-invoices-details__topup aeg-invoices__payment': isTopUpType(invoice.documentType) }"> 
                                {{
                                    isTopUpType(invoice.documentType) ? `+ ${formatCurrency(invoice.totalPrice)}` : formatCurrency(invoice.totalPrice)
                                }}
                            </span>
                        </div>
                    </td>
                    <td class="vl-u-align-center">
                        <vl-icon v-if="invoice.paid" mod-icon-only
                                 icon="check" hidden-text="Betaald" class="vl-u-align-center aeg-invoices__payment-icon">
                        </vl-icon>
                    </td>
                    <td class="vl-u-align-center">
                        <vl-link v-if="invoice.directPdfUrl" :href="invoice.directPdfUrl" mod-icon-only icon="file-office-pdf"
                                 hidden-text="Download als PDF" class="vl-u-align-center">
                        </vl-link>
                    </td>
                    <td class="vl-u-align-center">
                        <vl-link v-if="!isCreditsType(invoice) || invoice.directCsvUrl" :href="invoice.directCsvUrl" mod-icon-only
                                 icon="file-office-xls" hidden-text="Download als CSV" class="vl-u-align-center">
                        </vl-link>
                    </td>
                
                </tr>
                </tbody>
                <tfoot v-if="!emptyState">
                <tr>
                    <td colspan="2" class="aeg-invoices-download">
                        <vl-link :href="downloadFileUri" icon="download-harddisk" 
                                  mod-icon-before v-if="showDownloadLink">Download</vl-link>
                    </td>
                    <td colspan="8" class="aeg-datatable-pager">
                        <aeg-pagination v-if="invoices.pagingInfo.totalPages > 1" :page-size="invoices.pagingInfo.pageSize" :current-page="invoices.pagingInfo.page"
                                        :results="invoices.pagingInfo.totalPages"
                                        :total="invoices.pagingInfo.totalItems"
                                        @page-change="changePage" />
                    </td>
                </tr>
                </tfoot>
            </vl-data-table>
        </template>
    </vl-info-tile>
</div>
